const config = {
  // //Seassion
  // API_URL: "http://Novitra.top:8080/",
  // API_FTP: 'http://119.110.75.170:8013',

  // //DEV8081
//  API_URL: "http://Novitra.top:8081/",
  // API_FTP: "http://119.110.75.170:8013",

  //Cloud
   API_URL: "https://volupta-api.novitra.id/",
  API_FTP: "https://volupta-ftp.novitra.id",
  API_FTP_VIEW: "https://volupta-ftp.novitra.id",
  // API_FTP: 'http://192.168.18.215:3000',
};
export default config;
